<template>
  <ul class="tab-title">
    <template v-for="(item,index) in navList" :key="index">
      <li @click="changeIndex(index)" class="nav-item" :class="{'activeNav':curIndex===index}">
        <span class="img-icon" :style="{'background-position-x':item.bgPosX+'px'}"></span>
        <span>{{item.name}}</span>
      </li>
      <li v-if="index!==navList.length-1" class="line"></li>
    </template>
  </ul>
  <!-- 产品链接 -->
  <ul v-if="navList[curIndex].type === 3" class="product-link-list">
    <li v-for="(item,index) in navList[curIndex].productList" class="product-item" :key="index"
        @click="openUrl(item.linkUrl)">
      <span class="product-img" :style="{'background-image':'url('+item.imgUrl+')'}">
      </span>
      <span class="product-des">{{item.description}}</span>
      <div class="product-main">
        <span class="product-logo" :style="{'background-image':'url('+item.iconUrl+')'}"></span>
        <span class="product-name">{{item.name}}</span>
      </div>
    </li>
  </ul>
  <!-- 其他 -->
  <div class="other-wrap" v-else>
    <!-- 其他案例 -->
    <ul class="other-ul" v-if="navList[curIndex].type === 2">
      <li class="other-item" @click="changeOtherIndex(index)" :class="{activeOther:otherNavIndex===index}" :key="index"
          v-for="(item,index) in otherNavList">{{item.name}}
      </li>
    </ul>
    <ul class="nav-ul">
      <li class="scene-wrap" @click="showSceneDes(item)" v-for="(item,index) in sceneList" :key="index">
        <span class="scene-bg" :style="{'background-image':'url('+item.bgUrl+')'}"></span>
        <span class="scene-name overEllipsis">{{item.name}}</span>
      </li>
    </ul>
  </div>
  <Dialog v-if="dialogShow" @hideDialog="dialogShow=false" :currSceneInfo="currSceneInfo"/>
</template>
<script>
import { ref, reactive } from 'vue'
import Dialog from './Dialog'
import navList from 'navList'
import otherNavList from 'otherNavList'

export default {
  setup () {
    const curIndex = ref(0)
    const otherNavIndex = ref(0)
    const changeIndex = (i) => {
      curIndex.value = i
    }
    const changeOtherIndex = (i) => {
      otherNavIndex.value = i
    }
    const dialogShow = ref(false)
    const currSceneInfo = reactive({})
    const showSceneDes = (item) => {
      Object.assign(currSceneInfo, item)
      dialogShow.value = true
    }
    const openUrl = (url) => {
      window.open(url)
    }
    return {
      dialogShow,
      curIndex,
      otherNavIndex,
      changeIndex,
      changeOtherIndex,
      showSceneDes,
      openUrl,
      currSceneInfo
    }
  },
  components: {
    Dialog
  },
  data () {
    return {
      navList,
      otherNavList
    }
  },
  computed: {
    sceneList () {
      if (this.navList[this.curIndex].type === 3) {
        return []
      } else if (this.navList[this.curIndex].type === 2) {
        if (this.otherNavIndex === 0) {
          return this.otherNavList.reduce((total, item) => {
            total = [...total, ...item.sceneList]
            return total
          }, [])
        } else {
          return this.otherNavList[this.otherNavIndex].sceneList
        }
      } else {
        return this.navList[this.curIndex].sceneList
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .tab-title {
    display: flex;
    align-items: center;
    width: 90%;
    height: 5rem;
    margin: auto;
    background: rgba(0, 6, 21, 0.55);
    margin-bottom: 1.2rem;

    .nav-item {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      font-weight: 600;
      cursor: pointer;
      &.activeNav {
        background: linear-gradient(270deg, #2ab2f9 0%, #0c6ff6 100%);
        .img-icon {
          background-position-y: -60px;
        }
      }
    }
    .img-icon {
      width: 60px;
      height: 60px;
      margin-right: 10px;
      background-image: url(/static/demoSystem/navIcon.svg);
    }
    .line {
      width: 1px;
      height: 46px;
      background: #c8d8fd;
      opacity: 0.44;
    }
  }

  .nav-ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 20px;
  }

  .scene-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30%;
    margin-bottom: 2rem;
    padding-top: 16.875%;
    border: 1px solid #39465a;
    margin-right: 5%;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      border: 1px solid #007aff;
    }
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    .scene-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 40px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      background-color: rgba(0, 0, 0, 0.7);
    }
    .scene-name {
      height: 40px;
      font-size: 12px;
      line-height: 40px;
      background: #1d262e;
      padding: 0 10px;
    }
  }

  .other-wrap {
    display: flex;
    flex-direction: column;
    width: 70%;
    margin: auto;
  }

  .other-ul {
    display: flex;
  }

  .other-item {
    height: 32px;
    background: rgba(29, 31, 42, 0.9);
    border-radius: 16px;
    font-size: 14px;
    padding: 0 25px;
    line-height: 32px;
    text-align: center;
    margin-left: 16px;
    cursor: pointer;
    &.activeOther {
      background: #008aff;
    }
  }

  // 产品链接
  .product-link-list {
    width: 90%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .product-item {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f7f8;
    cursor: pointer;
    width: 47%;
    margin: 50px 1.5% 0;
  }

  @media screen and (min-width: 1920px) {
    .product-link-list {
      justify-content: center;
    }
    .product-item {
      width: 44%;
      margin: 50px 3% 0;
    }
  }

  @media screen and (max-width: 1300px) {
    .product-link-list {
      justify-content: center;
    }
    .product-item {
      width: 70%;
      &:nth-child(2n) {
        margin: 50px 0 0;
      }
    }
  }

  .product-img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .product-des {
    color: #666;
    font-size: 16px;
    line-height: 24px;
  }

  .product-main {
    width: 27%;
    height: 100px;
    margin: 0 5%;
    background: #ffffff;
    box-shadow: 0px 4px 15px 0px rgba(60, 186, 255, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .product-logo {
    width: 34px;
    height: 34px;
    background-repeat: no-repeat
  }

  .product-name {
    font-weight: bold;
    color: #333333;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-top: 4px;
  }
</style>
